/**
 * Product-picker SERP copy. Tuned for high-CTR “picker / selector / finder”
 * queries and weaker ski/TV CTR from GSC.
 *
 * Intro/description style (match snowboard):
 * “Find the right [product] for [key factors]. Answer a few questions for a personalized pick.”
 */

const PICKER_SEO = {
  snowboard: {
    title: "Snowboard Finder | Find Your Ideal Board | SimplyBuy",
    description:
      "Find the right snowboard for your riding style, terrain, and skill level. Answer a few questions for a personalized pick.",
  },
  'snowboard-binding': {
    title: "Snowboard Binding Finder | Find the Right Bindings | SimplyBuy",
    description:
      "Find the right snowboard bindings for your boots, board, and riding style. Answer a few questions for a personalized pick.",
  },
  'snowboard-boots': {
    title: "Snowboard Boot Finder | Find Your Perfect Fit | SimplyBuy",
    description:
      "Find the right snowboard boots for your riding style, flex, and fit. Answer a few questions for a personalized pick.",
  },
  'snowboard-jacket': {
    title: "Snowboard Jacket Finder | Find Your Ideal Jacket | SimplyBuy",
    description:
      "Find the right snowboard jacket for warmth, waterproofing, fit, and features. Answer a few questions for a personalized pick.",
  },
  ski: {
    title: "Ski Finder | Find Your Perfect Skis | SimplyBuy",
    description:
      "Find the right skis for your ability, terrain, and size. Answer a few questions for a personalized pick.",
  },
  'mountain-bike': {
    title: "Mountain Bike Finder | Find Your Ideal Ride | SimplyBuy",
    description:
      "Find the right mountain bike for your terrain, travel, and budget. Answer a few questions for a personalized pick.",
  },
  headphones: {
    title: "Headphones Finder | Find Your Perfect Pair | SimplyBuy",
    description:
      "Find the right headphones for how you listen — noise canceling, wired, gaming, and more. Answer a few questions for a personalized pick.",
  },
  monitor: {
    title: "Monitor Finder | Find Your Ideal Display | SimplyBuy",
    description:
      "Find the right monitor for work, gaming, or creative use. Answer a few questions for a personalized pick.",
  },
  barbell: {
    title: "Barbell Finder | SimplyBuy",
    description:
      "This product picker is no longer offered on SimplyBuy.",
  },
  tv: {
    title: "TV Finder | Find the Best TV for Your Budget | SimplyBuy",
    description:
      "Find the right TV for your budget, size, and performance. Answer a few questions for a personalized pick.",
  },
  'pickleball-paddle': {
    title: "Pickleball Paddle Finder | Find Your Perfect Paddle | SimplyBuy",
    description:
      "Find the right pickleball paddle for your skill level and play style. Answer a few questions for a personalized pick.",
  },
}

const DEFAULT_SEO = {
  title: 'SimplyBuy | Personalized Product Pickers',
  description:
    'Find the right product for your needs. Answer a few questions for a personalized pick.',
}

const OG_IMAGE = 'https://simplybuy.io/simplybuy-favicon.png'

export function getPickerSeo(slug) {
  const base = PICKER_SEO[slug] || DEFAULT_SEO
  const path =
    slug === 'tv'
      ? '/buyangle/tv/'
      : slug
        ? `/product-picker/${slug}/0`
        : '/'
  return {
    ...base,
    url: `https://simplybuy.io${path}`,
    image: OG_IMAGE,
  }
}

/** On-page H1 / FAQ CTA: always “[Topic] Finder”. */
export function pickerH1Label(topicName) {
  if (!topicName) return 'Finder'
  return `${topicName} Finder`
}

export function pickerJsonLd(slug) {
  const seo = getPickerSeo(slug)
  const topicLabel = seo.title.split('|')[0].trim()
  return {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: topicLabel,
    url: seo.url,
    description: seo.description,
    applicationCategory: 'ShoppingApplication',
    operatingSystem: 'Any',
    isAccessibleForFree: true,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    provider: {
      '@type': 'Organization',
      name: 'SimplyBuy',
      url: 'https://simplybuy.io',
    },
  }
}
